<template>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex>
          <v-card>
            <v-toolbar>
              <v-toolbar-title>Sign Up</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                name="email"
                label="Email"
                v-model="email"
                type="email"
                hint="Please enter your email address here"
                :rules="[() => email.length > 0 || 'This field is required']"
                required>
              </v-text-field>
              <v-text-field
                name="password"
                label="Password"
                v-model="password"
                type="password"
                hint="Please enter your password here"
                :rules="[() => password.length > 0 || 'This field is required']"
                required>
              </v-text-field>
              <v-text-field
                name="confirmPassword"
                label="Confirm Password"
                v-model="confirmPassword"
                type="password"
                hint="Please re-enter password here"
                :rules="[comparePasswords]">
              </v-text-field>
              <small>*indicates required field</small>
              <br>
              <div class="red--text" v-html="error"></div>
              <br>
              <v-btn @click="register" :disabled="loading" :loading="loading">
                Register
                <span slot="loader" class="custom-loader">
                  <v-icon light>cached</v-icon>
                </span>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import mixins from '@/mixins.js'
import AuthenticationService from '@/services/AuthenticationService'
export default {
  data () {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      error: null
    }
  },
  mixins: [mixins],
  computed: {
    comparePasswords () {
      return this.password != this.confirmPassword ? 'Passwords do not match' : ''
    },
    loading() {
      return this.$store.getters.loading
    }
  },
  methods: {
    async register () {
      try {
        const response = await AuthenticationService.register({
          email: this.email,
          password: this.password
        })
        this.error = 'Register Successful'
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        this.$router.push({
          name: 'homeLoggedIn'
        })
      } catch (error) {
        this.error = this.handleError(error)
      }
    }
  }
}
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/Register.vue